<template>
    <div>
        <nav class="navbar fixed-bottom bg-dark text-footer">
            <div v-if="showTestingBanner" class="text-center text-white col-md-12"
                style="background-color: rgb(241, 45, 45);">
                <span style="margin: auto; font-weight: bold;">AMBIENTE DE PRUEBAS - AMBIENTE DE PRUEBAS - AMBIENTE DE
                    PRUEBAS - AMBIENTE DE PRUEBAS
                    - AMBIENTE DE PRUEBAS</span>
            </div>
            <div>© {{ year }} Copyright: Ventisquero Wine Estates</div>
            <div>
                <a class="btn btn-info text-white btn-sm" target="_blank" :href="manualLink"
                    :title="'Manual de Usuario ' + user.roles"><i class="fas fa-book mr-2"></i>Manual de Usuario
                </a>
                Developed by<a href="https://www.dimabe.cl/">
                    <img class="dimabe-logo mr-4 ml-2" src="/logo_dimabe.png" /></a>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    props: ["user"],
    name: "footer-dimabe",
    data() {
        return {
            year: "",
            apiUrl: this.$store.getters.apiUrl,
            showTestingBanner: this.$store.getters.apiUrl !== 'https://fcomapi.ventisquero.com/api/'
        };
    },
    created() {
        var date = new Date();
        this.year = date.getFullYear();
    },
    computed: {
        manualLink() {
            let role = "";
            if (this.user.roles == "Administrador") role = "Administrador";
            if (this.user.roles == "Comercial" || this.user.roles == "Jefe Comercial")
                role = "Comercial";
            if (this.user.roles == "Enologia") role = "Enología";
            if (this.user.roles == "Bodega") role = "Despacho";
            if (this.user.roles == "Courier") role = "Courier";
            if (this.user.roles == "Calidad") role = "Calidad";
            let manual = "Manual de Usuario - FCOM - Perfil " + role + ".pdf";
            return "/Manuals/" + manual;
        },
    },
};
</script>
<style>
.footer {
    background-color: #1c2023;
    position: fixed;
    width: 100%;
    height: 80px;
    bottom: 0 important !;
    left: 0;
}

.text-footer {
    color: rgb(179, 178, 178);
    margin: 0 auto;
}

.dimabe-logo {
    width: 100px;
}

#wrapper {
    padding-bottom: 80px;
    min-height: calc(100% - 80px);
    position: relative;
}
</style>
